import CryptoJS from 'crypto-js';
import store  from '@/stores/store';
class MisaID {
  /**
   * Khởi tạo thông tin Client
   * @param {*} settings Thông tin Client
   * @createdBy NTQuyen 23/09/2021
   */
  constructor(settings) {
    this.configs = {
      client_id: settings.client_id,
      authority: settings.authority,
      redirect_uri: settings.redirect_uri,
      post_logout_uri: settings.post_logout_uri,
      request_type: settings.request_type,
      scopes: settings.scopes,
      response_mode: settings.response_mode,
      response_type: settings.response_type,
      sign_in_path: `${settings.authority}account/login?returnUrl=`,
      register_path: `${settings.authority}account/register?returnUrl=`,
      logout_path: `${settings.authority}Account/Logout?postLogoutRedirectUri=`,
      authorize_path: '/connect/authorize/callback?client_id=',
    };
  }

  /**
   * Hàm sinh chuỗi Code Verifier
   * @returns Code Verifier
   * @createdBy NTQuyen 23/09/2021
   */
  GenerateCodeVerifier() {
    var code_verifier = this.GenerateRandomString(128);
    return code_verifier;
  }

  /**
   * Hàm sinh Random String
   * @param {*} length Độ dài chuỗi String muốn sinh ra
   * @returns Random String
   * @createdBy NTQuyen 23/09/2021
   */
  GenerateRandomString(length) {
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var text = '';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  /**
   * Hàm tạo Code Challenge
   * @param {*} code_verifier Code Verifier
   * @returns Chuối Code Challenge khi đã được mã hóa với SHA256
   * @createdBy NTQuyen 23/09/2021
   */
  GenerateCodeChallenge(code_verifier) {
    return this.Base64URL(CryptoJS.SHA256(code_verifier));
  }

  /**
   * Hàm mã hóa Base64
   * @param {*} string Chuỗi ký tự muốn Base64
   * @returns Chuỗi ký tự đã Base64
   * @createdBy NTQuyen 23/09/2021
   */
  Base64URL(string) {
    return string
      .toString(CryptoJS.enc.Base64)
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  }

  /**
   * Hàm Build Url đăng ký/đăng nhập
   * @param {*} type  Loại url 0. Đăng nhập, 1. Đăng ký
   * @returns  Url redirect
   * @createdBy NTQuyen 23/09/2021
   */
  RedirectUrl(type) {
    var codeVerifier = this.GenerateCodeVerifier();
    var state = this.GenerateRandomString(43);
    var codeChallenge = this.GenerateCodeChallenge(codeVerifier);
    var that = this.configs;
    var client = {
      code_verifier: codeVerifier,
      code_challenge: codeChallenge,
      state: state,
      client_id: that.client_id,
      authority: that.authority,
      redirect_uri: that.redirect_uri,
      post_logout_uri: that.post_logout_uri,
      request_type: that.request_type,
      scopes: that.scopes,
      response_mode: that.response_mode,
      response_type: that.response_type,
      sign_in_path: that.sign_in_path,
      register_path: that.register_path,
      logout_path: that.logout_path,
      authorize_path: that.authorize_path,
    };

    localStorage.setItem(that.client_id, JSON.stringify(client));

    var finalPath = '';
    var commonPath = encodeURIComponent(
      `${client.authorize_path}${that.client_id}&redirect_uri=${client.redirect_uri}&scope=${client.scopes}&state=${client.state}`
    );
    if (that.response_type == 'code') {
      //Nếu là luồng oauthorization_code
      var extendPath1 = encodeURIComponent(
        `&response_type=${client.response_type}&code_challenge=${client.code_challenge}&code_challenge_method=S256&response_mode=${client.response_mode}`
      );
      finalPath = commonPath + extendPath1;
    } else if (that.response_type.includes('token')) {
      //Nếu là luồng implicit
      var extendPath = encodeURIComponent(
        `&response_type=${client.response_type}`
      );
      finalPath = commonPath + extendPath;
    } else {
      throw 'Invalid response_type!';
    }

    var url = '';
    if (type == 0) {
      url = that.sign_in_path + finalPath;
    } else if (type == 1) {
      url = that.register_path + finalPath;
    } else {
      throw 'Invalid Type!';
    }

    return url;
  }

  /**
   * Hàm build Url Logout
   * @returns Url logout được build
   * @createdBy NTQuyen 23/09/2021
   */
  Logout() {
    var that = this.configs;
    var logoutUrl = `${that.logout_path}${that.post_logout_uri}&clientId=${that.client_id}`;
    localStorage.removeItem(that.client_id);
    store.commit('context/removeToken');
    return logoutUrl;
  }

  /**
   *
   * @param {*} url Url muốn Paser thông tin
   * @returns Mảng Data khi Paser thông tin
   * @createdBy NTQuyen 23/09/2021
   */
  ParseURLParams(url) {
    var queryStart = url.indexOf('?') + 1,
      queryEnd = url.indexOf('#') + 1 || url.length + 1,
      query = url.slice(queryStart, queryEnd - 1),
      pairs = query.replace(/\+/g, ' ').split('&'),
      parms = {},
      i,
      n,
      v,
      nv;

    if (query === url || query === '') return;

    for (i = 0; i < pairs.length; i++) {
      nv = pairs[i].split('=', 2);
      n = decodeURIComponent(nv[0]);
      v = decodeURIComponent(nv[1]);

      if (!Object.prototype.hasOwnProperty.call(parms, n)) parms[n] = [];
      parms[n].push(nv.length === 2 ? v : null);
    }
    console.log(parms[1]);
    return parms;
  }

  /**
   * Lấy thông tin từ Url
   * @returns Mảng Data khi Parse Url
   * @createdBy NTQuyen 23/09/2021
   */
  SigninCallback() {
    var params = this.ParseURLParams(window.location.href);
    return params;
  }

  HttpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false); // false for synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
  }
}

export default new MisaID(window._misaId);
